import React from "react";
import _ from "lodash";
import ProductCardComponent from "../ProductCard/ProductCardComponent";
import ListingFilterSectionComponent from "../ListingContent/ListingFilterSection/ListingFilterSectionComponent";
import { useEffect, useState } from "react";

import EventSliderFilterSection from "../Event/EventSliderFilter";
import ErrorSection from "../../ErrorPage/ErrorSection";
import "./CoachingListSection.scss";
import { Tab, Tabs } from "react-bootstrap";
import useLogin from "../../../custom-hooks/useLogin";
import CoachingListSection from "./CoachingListSection";
import MyCoachingListSection from "./MyCoachingListSection";
import { useSelector } from "react-redux";

function CoachingListSectionParent() {
  
  const { isLoggedIn } = useLogin();
  const [key, setKey] = useState("coach");

  const search = window.location.search;
  const params = new URLSearchParams(search);
  const c = params.get("c");
  let allPartners="";
  let providerName= "";
  if (c) {
    let decodedString = atob(c);
    let paramsReq = JSON.parse(decodedString);
    allPartners = paramsReq?.allPartners;
    providerName = paramsReq?.provider_name;
  }
  const authBroker = useSelector((state) => state.auth.authBroker);
  
  useEffect(() => {
    window.scrollTo(0, 0);
 
  }, []);

  const renderCoaching = ()=>{
    if(key==="coach"){
      return <CoachingListSection />
    }else {
      return <MyCoachingListSection />
    }
  }

  const renderTitle = () => {
    return (
    <div dangerouslySetInnerHTML={{__html: allPartners ? `Services by ${authBroker?.payload?.user?.config?.partner_menu_text !== undefined && !_.isEmpty(authBroker?.payload?.user?.config?.partner_menu_text)?
      authBroker?.payload?.user?.config?.partner_menu_text?.toLowerCase():
      "Learning Partners"}`: providerName ? `Services by ${providerName}` : "Services"}}></div>
    )
}

  return (
    <>
      <div className="contsection">
        <nav>
          <div className="nav nav-tabs" id="nav-tab" role="tablist">
          <Tabs
          underline
          activeKey={key}
          onSelect={(k) => {
            // setIsFetching(true)
            console.log("selectKey: ", k);
            setKey(k);
            if (k === "certi") {
              
            } else {
              
            }
          }}
        >
          <Tab eventKey={"coach"} title={renderTitle()}></Tab>
          {isLoggedIn && false && (
            <Tab eventKey={"myCoach"} title="My coaching"></Tab>
          )}
        </Tabs>
          </div>
        </nav>
        {renderCoaching()}
      </div>
    </>
  );
}

export default CoachingListSectionParent;
